
import React from 'react';
import SEO from './SEO';
import CanonicalLink from './CanonicalLink';
import { useRedirection } from '@/hooks/useRedirection';

interface EnhancedSEOProps {
  title?: string;
  description?: string;
  canonical?: string;
  ogType?: string;
  ogImage?: string;
  structuredData?: Record<string, any>;
  localBusiness?: {
    city?: string;
    region?: string;
    postalCode?: string;
    serviceType?: string;
  };
  robots?: string;
  keywords?: string;
  author?: string;
  preloadImages?: string[];
  alternateLanguages?: { hreflang: string; href: string }[];
  articleData?: {
    datePublished?: string;
    dateModified?: string;
    author?: string;
    section?: string;
  };
  forceCanonical?: boolean;
}

const EnhancedSEO: React.FC<EnhancedSEOProps> = ({
  canonical,
  forceCanonical = false,
  ...seoProps
}) => {
  const { currentCanonical } = useRedirection();

  // Utiliser la canonicalisation automatique si aucune canonical n'est fournie
  const finalCanonical = canonical || (forceCanonical ? undefined : currentCanonical);

  return (
    <>
      <SEO
        {...seoProps}
        canonical={finalCanonical}
      />
      <CanonicalLink customCanonical={finalCanonical} />
    </>
  );
};

export default EnhancedSEO;
